import Firebase from 'firebase'
import 'firebase/firestore'

const config = {
  apiKey: 'AIzaSyAKB_kqgqQZP-Ad4HYdfkgDBQqS6i_w7c0',
  authDomain: 'kanpo-c50cd.firebaseapp.com',
  databaseURL: 'https://kanpo-c50cd.firebaseio.com',
  projectId: 'kanpo-c50cd',
  storageBucket: 'kanpo-c50cd.appspot.com',
  messagingSenderId: '648056008446',
  appId: '1:648056008446:web:75e29aa5559d8303'
}

const firebaseApp = Firebase.initializeApp(config, 'exercise-vue')
const firestore = firebaseApp.firestore()
export default firestore
